import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { FaLinkedin, FaGithub,  FaCodepen, FaBehance } from 'react-icons/fa'
import styled from 'styled-components'
import { About } from '../components'
import config from '../../config/website'
import  '../styles/nav.scss';


const Wrapper = styled.header`
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 1rem 0 1rem 0;
    position: relative;
    z-index: 1000;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
     a {
        color: ${props => props.theme.colors.black};
        text-decoration: none;
        transition: all 0.3s ease-in-out;
        z-index: 100;
        &:hover {
        color: ${props => props.theme.brand.primary};
        }
    }
    .flex__row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
                flex: 0 0 100%;
        width: 100%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding: 1rem 0 1rem 0;
        flex-wrap: wrap;
    }
    .social--mobile {color: #fff;}
`

const Nav = styled.nav`
    display: flex;
    flex: 1;
    justify-content: flex-start;
    padding: 0 ${props => props.theme.spacer.horizontal};
    a:not(:first-child) {
            margin-left: 1rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}), (max-device-width: ${props => props.theme.breakpoints.m}) {
        padding: 0 1rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding: 0 1rem;
        display: none;
    }
`

const Name = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    a {
        font-size: 1.25rem;
        font-family: 'Roboto Slab', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        font-weight: 400;
        &:hover,
        &:focus {
        color: ${props => props.theme.colors.body_color};
        text-decoration: none;
        }
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}) {
        order: 1;
        flex: 1 0 100%;
        margin-bottom: 0.75rem;
    }
    .site-desc {
        padding: 0;
        margin: 0;
        font-size: .7rem;
        line-height: 1.5;
        letter-spacing: 2px;
        font-family: Roboto, sans-serif;
        font-weight: normal;
    }
    .nav__title--mobile {
        color: #fff;
        padding-top: 1rem;
    }
`

const SocialMedia = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    padding: 0 ${props => props.theme.spacer.horizontal};
    a {
        font-size: 1.25rem;
        line-height: 20px;
    }
    a:not(:first-child) {
        margin-left: 1rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding: 0 1rem;
        display:none;
    }
`

const SocialMediaNav = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    padding: 0 ${props => props.theme.spacer.horizontal};
    a {
        font-size: 1.25rem;
        line-height: 20px;
    }
    a:not(:first-child) {
        margin-left: 1rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 80vh;
    }
`

// Grabs all MDX files from src/pages and puts them into the navigation

const Navigation = () => {
  const data = useStaticQuery(query)

  return (
    <Wrapper data-testid="navigation">
        <div className="flex__row">
            <Nav>
                 <Link to="/works" data-testid="home-title-link2" activeClassName="nav-active">
                    01. Works
                </Link>
                {data.nav.nodes.map((n, index) => (
                <Link key={n.fields.slug} to={n.fields.slug} data-testid={`navItem-${index}`} activeClassName="nav-active">
                    {n.frontmatter.title}
                </Link>
                ))}
            </Nav>

            <Name>
                <Link to="/" data-testid="home-title-link">
                    {config.siteTitle}
                </Link>
            </Name>

            <SocialMedia>
                <a href="https://www.linkedin.com/in/silviu-stefanescu-793a2a48/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" ><FaLinkedin  /> </a>
                <a href="https://github.com/silviu-stefanescu" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FaGithub /> </a>
                <a href="https://codepen.io/silviustefanecu/" target="_blank" rel="noopener noreferrer" aria-label="CodePen"><FaCodepen /></a>
                <a href="https://www.behance.net/silviunicolae" target="_blank" rel="noopener noreferrer" aria-label="Behance"><FaBehance /></a>
            </SocialMedia>
        </div>

        <div className="navigation--mobile">
            <input type="checkbox" className="navigation__checkbox" id="navi-toggle" />

            <label for="navi-toggle" className="navigation__button">
                <span className="navigation__icon">&nbsp;</span>
            </label>

            <div className="navigation__background">&nbsp;</div>

            <div className="navigation__nav">
                <Name>
                    <Link className="nav__title--mobile" to="/" data-testid="home-title-link-mobile">
                        {config.siteTitle}
                    </Link>
                </Name>
                <ul className="navigation__list">
                    <li className="navigation__item">
                        <Link className="navigation__link" to="/works" data-testid="home-title-link2" data-scroll-speed="1000" data-scroll-offset="0">
                            <span>01.</span> Works
                        </Link>
                    </li>
                    <li className="navigation__item">
                        <Link className="navigation__link" to="/about" data-testid="home-title-link3" data-scroll-speed="1000" data-scroll-offset="0">
                            <span>02.</span> About
                        </Link>
                    </li>
                    <li className="navigation__item">
                        <Link className="navigation__link" to="/contact" data-testid="home-title-link5" data-scroll-speed="1000" data-scroll-offset="0">
                            <span>04.</span> Contact
                        </Link>
                    </li>
                </ul>
                <SocialMediaNav>
                    <a className="social--mobile" href="https://www.linkedin.com/in/silviu-stefanescu-793a2a48/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" ><FaLinkedin  /> </a>
                    <a className="social--mobile" href="https://github.com/silviu-stefanescu" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FaGithub /> </a>
                    <a className="social--mobile" href="https://codepen.io/silviustefanecu/" target="_blank" rel="noopener noreferrer" aria-label="CodePen"><FaCodepen /></a>
                    <a className="social--mobile" href="https://www.behance.net/silviunicolae" target="_blank" rel="noopener noreferrer" aria-label="Behance"><FaBehance /></a>
                </SocialMediaNav>
            </div>
        </div>


         <About></About>
    </Wrapper>
  )
}

export default Navigation

const query = graphql`
  query NavLinks {
    nav: allMdx(filter: { fields: { sourceInstanceName: { eq: "pages" } } }) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          title
        }
      }
    }
  }
`
